var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-10 -10 510 210",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(80, 80, 80)"
    },
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 200,
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(80, 80, 80)"
    },
    x1: 100,
    x2: 100,
    y1: 0,
    y2: 200,
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(80, 80, 80)"
    },
    x1: 200,
    x2: 200,
    y1: 0,
    y2: 200,
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(80, 80, 80)"
    },
    x1: 300,
    x2: 300,
    y1: 0,
    y2: 200,
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(80, 80, 80)"
    },
    x1: 400,
    x2: 400,
    y1: 0,
    y2: 200,
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(80, 80, 80)"
    },
    x1: 500,
    x2: 500,
    y1: 0,
    y2: 200,
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(80, 80, 80)"
    },
    x1: 0,
    x2: 500,
    y1: 0,
    y2: 0,
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(80, 80, 80)"
    },
    x1: 0,
    x2: 500,
    y1: 40,
    y2: 40,
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(80, 80, 80)"
    },
    x1: 0,
    x2: 500,
    y1: 80,
    y2: 80,
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(80, 80, 80)"
    },
    x1: 0,
    x2: 500,
    y1: 120,
    y2: 120,
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(80, 80, 80)"
    },
    x1: 0,
    x2: 500,
    y1: 160,
    y2: 160,
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(80, 80, 80)"
    },
    x1: 0,
    x2: 500,
    y1: 200,
    y2: 200,
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/Grid.0b6aa8eb1b8f9981085f043ca35f5c04.svg";
export { ForwardRef as ReactComponent };